/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SharedHeadLinkTags_metadata$ref: FragmentReference;
export type SharedHeadLinkTags_metadata = {|
  +canonical: ?string,
  +disableIndexing: ?boolean,
  +next: ?string,
  +prev: ?string,
  +$refType: SharedHeadLinkTags_metadata$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SharedHeadLinkTags_metadata",
  "type": "MetaData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canonical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "disableIndexing",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "next",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "prev",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fe44edbfd9fb00feb7d3dea57ccd37d2';
module.exports = node;
